<template>
  <transition name="fade">
    <div id="app" v-show="initialized">
      <main class="flex">
        <SideNavigation :data="details" :user="user" />
        <div style="flex: 0 0 285px;" />
        <div
          :class="
            details.publicProfilesOnly
              ? 'col12-of-12--medium-up'
              : 'col10-of-12--medium-up'
          "
          style="background-color: #f7f7f7; width: 100%; padding-bottom: 2rem;"
        >
          <div
            style="min-height: 101vh; width: 90%; max-width: 1500px; margin: 0 auto; padding-top: 34px;"
          >
            <router-view v-show="!loading" />
          </div>
        </div>
      </main>
    </div>
  </transition>
</template>

<script>
import SideNavigation from '@/components/DesignSystem/SideNavigation';
import VendorStore from '@/store/vendorDashboard/index';
import router from '@/router/dashboard/index';
import { mapGetters, mapActions } from 'vuex';
import '@/scss/directory.scss';
import '@/scss/web.scss';

export default {
  components: {
    SideNavigation,
  },
  async created() {
    this.$store.registerModule('vendorDashboard', VendorStore);
    this.$router.addRoutes(router.options.routes);
    this.fetchFilters();
    this.fetchTiers();
    this.fetchCategories();
    this.fetchCollections();
    this.fetchBadges();
    await this.fetchDetails();

    setTimeout(() => {
      this.$emit('initialized');
      this.initialized = true;
    }, 500);

    if (this.details.publicProfilesOnly) {
      var fromGetListed = this.$route.query.gotListed;
      if (fromGetListed == undefined) {
        this.$router.replace('/our-public-profiles');
      } else if (fromGetListed == true) {
        this.$router.replace(window.location.pathname);
      }
    }
  },
  computed: {
    ...mapGetters(['userMessage', 'loading', 'details', 'user']),
  },
  methods: {
    ...mapActions([
      'fetchFilters',
      'fetchTiers',
      'fetchCategories',
      'fetchCollections',
      'fetchBadges',
      'fetchDetails',
    ]),
  },
  data() {
    return {
      initialized: false,
    };
  },
};
</script>
